export const isObject = (object) =>
  typeof object === 'object' && !Array.isArray(object) && object !== null;

export const isEmptyObject = (object, nested = false) => {
  if (!isObject(object)) {
    return false;
  }

  if (nested) {
    object = removeNullValuesNestedObject(object);
  }

  return Object.keys(object).length === 0;
};

export const removeNullValues = (object) =>
  Object.fromEntries(
    Object.entries(object).filter(
      ([key, value]: [string, any]) => value !== null && value?.length !== 0
    )
  );

export const removeNullValuesNestedObject = (object) => {
  Object.entries(object).forEach(([key, value]: [string | number, any]) => {
    if (value && isObjectOrArray(value)) {
      removeNullValuesNestedObject(value);
    }

    if (
      (value && isObjectOrArray(value) && !Object.keys(value).length) ||
      value === null ||
      value === undefined
    ) {
      if (Array.isArray(object)) {
        object.splice(key as number, 1);

        return;
      }

      delete object[key];
    }
  });

  return object;
};

export const keyExists = (object: any, key = 'id') => {
  if (!object || (!isObject(object) && !Array.isArray(object))) {
    return false;
  }

  if (Object.hasOwn(object, key) && Boolean(object[key])) {
    return true;
  }

  if (Array.isArray(object)) {
    for (let i = 0; i < object.length; i++) {
      const result = keyExists(object[i], key) && Boolean(object[i][key]);

      return Boolean(result);
    }
  }

  for (const k in object) {
    const result = keyExists(object[k], key);

    return Boolean(result);
  }

  return false;
};

// clones an object including the files child objects
export const cloneDeepWithFile = (object) => {
  let clonedObject = { ...object };
  Object.entries(object).map(([key, value]) => {
    if (value instanceof FileList) {
      const files = new DataTransfer();
      Array.from(value).forEach((file) => {
        files.items.add(new File([file], file.name, { type: file.type }));
      });
      clonedObject = { ...clonedObject, [key]: files?.files };

      return;
    }

    if (isObject(value)) {
      clonedObject = { ...clonedObject, [key]: cloneDeepWithFile(value) };
    }
  });

  return clonedObject;
};

// Clones deep an array of objects.
// Method is needed when using remove entry for useFieldArray from react-hook-form with file inputs.
// (when `remove(index)` is called, the files from the inputs that are positioned after `index` in the
// form are lost, so copying the values before `remove(index)` is needed and reset the form after that
// with values including the file input values)
export const cloneArrayOfObjects = (objects, excludeDeletedIndex?) => {
  const clonedObjects = [];
  objects.forEach((object, key) => {
    if (key === excludeDeletedIndex) {
      return;
    }

    clonedObjects.push(cloneDeepWithFile(object));
  });

  return clonedObjects;
};

const isObjectOrArray = (object) =>
  typeof object === 'object' && object !== null;
